import axios from "axios";
import { REACT_APP_API, environment } from "../environment";

const getTokenFromStorage = () => {
  return sessionStorage.getItem("token");
};
const token = getTokenFromStorage();

let headers = {
  "Content-Type": "application/json",
  "Authorization": token,
};

const route = environment === "preprod" ? '/preprod' : '';

export const loginSSO = () => {
  return axios.post(`${REACT_APP_API}/sso_login${route}`, {
    origin: window.location.origin
  });
}
 
export const redirectSSO = (code) => {
  const postBootTarget = sessionStorage.getItem("postBootTarget");

  return axios.post(`${REACT_APP_API}/sso_redirect${route}`, { 
    data: code,
    origin: window.location.origin,
    postBootTarget: postBootTarget
  });
}
